<template>
  <div
    class="dashboard-card"
    :style="{
      borderLeftColor: borderColor,
      borderColor: `var(--card-border, #1a2745)`, /* 整体边框颜色兜底 */
      boxShadow: `inset 2px 0 10px -5px ${borderColor}` /* 增加一点左侧内发光效果，更贴近UI */
    }"
  >
    <!-- 头部区域：图标和标题 -->
    <div class="card-header">
      <span class="icon-wrapper">
        <!-- 默认插槽：支持外部传入自定义图标。如果没有传入，则显示默认的 SVG 图标 -->
        <slot name="icon">
          <!-- 默认图标 (一辆小车) -->
          <svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round">
            <rect x="1" y="3" width="15" height="13"></rect>
            <polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon>
            <circle cx="5.5" cy="18.5" r="2.5"></circle>
            <circle cx="18.5" cy="18.5" r="2.5"></circle>
          </svg>
        </slot>
      </span>
      <span class="title-text">{{ title }}</span>
    </div>

    <!-- 数据区域 -->
    <div
      class="card-value"
      :style="{ color: borderColor }"
    >
      {{ displayValue }}
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  // 标题文字，不传则显示默认文字
  title: {
    type: String,
    default: '已投放无人车总量'
  },
  // 左侧边框颜色 (同时作为数字的颜色，与图中设计一致)，不传则使用默认的青蓝色
  borderColor: {
    type: String,
    default: '#00d8ff'
  },
  // 数据数值
  value: {
    type: [Number, String],
    default: null
  }
})

// 计算属性：处理数字展示逻辑，不传或为空时展示 '--'
const displayValue = computed(() => {
  if (props.value === null || props.value === undefined || props.value === '') {
    return '--'
  }
  return props.value
})
</script>

<style scoped>
/* 卡片主体样式 */
.dashboard-card {
  background-color: #0d1528; /* 深色背景，贴近截图 */
  border: 1px solid;
  border-radius: 6px;
  padding: 16px 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 12px; /* 标题和数字之间的间距 */
  border-left-width: 3px; /* 左侧边框加粗 */
  border-left-style: solid;
  transition: all 0.3s ease;
}

/* 悬浮效果 (可选) */
.dashboard-card:hover {
  background-color: #121c33;
}

/* 头部样式 */
.card-header {
  display: flex;
  align-items: center;
  gap: 8px; /* 图标和文字的间距 */
}

/* 图标容器样式 */
.icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #7b8ab0; /* 默认图标颜色 */
}

/* 标题文字样式 */
.title-text {
  color: #7b8ab0; /* 灰蓝色字体 */
  font-size: 14px;
}

/* 数字样式 */
.card-value {
  font-size: 24px;
  font-weight: bold;
  font-family: Arial, Helvetica, sans-serif; /* 建议使用等宽或数字字体 */
  line-height: 1;
}
</style>
